<template>
     <div style="width:1300px;margin:0 auto;">
            <div v-show="showVue" class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:100px;">
                <p class="text-center mb-2">
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
                               <div>
                                      <div v-for="(item,index) in yulan" :key="index">
                                             <span>
                                                  浏览人:
                                             </span>
                                             <span>
                                                  {{item.truename}}
                                             </span>
                                              <span class="ml-1">
                                                 浏览次数:
                                            </span>
                                            <span style="font-size:17px;font-weight:bold;color:red;">
                                                 {{item.count}}
                                            </span>
                                            <span class="ml-5">
                                                 {{item.inserttime}}
                                            </span>
                                      </div>
                                         
                                       <h4>
                                             {{zhutitle}}
                                       </h4>
                                      <h5 class="text-center header_title">
                                           <span>
                                                 {{title}}
                                           </span>
                                      </h5>
                                       <p class="text-right">
                                            <button v-if="iscollect" class="btn btn-danger" @click="quxiao()">
                                                  <span>
                                                       取消收藏
                                                  </span>
                                            </button>
                                            <!-- <button v-else class="btn btn-primary" @click="shouchang()">
                                                  <span>
                                                    收藏会议
                                                  </span>
                                            </button> -->
                                       </p>
                                                  <div class="body_content">
                                                       <section v-html="content" class="mt-2" style="font-size:20px;text-indent:40px;line-height:50px;">
                                                                 {{content}}
                                                       </section>
                                                       <h6 class="mt-5">
                                                            下发部门:
                                                             <span v-for="(item,index) of bumen" :key="index">
                                                                 <span class="ml-2" style="color:#36d">
                                                                       {{item.departmentname}}
                                                                 </span>
                                                             </span>
                                                       </h6>
                                                           
                                                            <div class="mt-5">
                                                             
                                                                 <div class="image_content">
                                                                      <viewer class="mt-2" :images="imgData"   v-for="(item,index) in imgData"  :key="index"> 
                                                                                <img v-if="item!=''" class="Image mr-1 limg"
                                                                                     :src="'http://fw.hyey.cn'+item"
                                                                                     alt=""
                                                                                >
                                                                      </viewer>
                                                                 </div>
                                                                 <div v-if="fileurl[0]!=null&&fileurl[0]!=''" class="mt-4">
                                                                      <span style="color:red;">
                                                                        附件:
                                                                      </span>
                                                                       <div>
                                                                             <table style="width:500px;">
                                                                                  <tr class="text-center">
                                                                                       <th>文件名</th>
                                                                                        <th>操作</th>
                                                                                  </tr>
                                                                                  <tr class="text-center" v-for="(item,index) in fileurl" :key="index">
                                                                                       <td v-if="item!=''" style="color:blue;line-height:30px;">
                                                                                            <a>
                                                                                              {{item | handler}}
                                                                                            </a>
                                                                                       </td>
                                                                                       <td v-if="item!=''">
                                                                                            <button class="bg-primary button_zi heit" @click="upload(item)">
                                                                                                 下载
                                                                                            </button>
                                                                                       </td>
                                                                                  </tr>
                                                                             </table>
                                                                       </div>
                                                                 </div>

                                                            </div>
                                                            <div v-if="showHuifu">
                                                                 <div v-for="(item,index) in huifu" :key="index">
                                                                      <p class="mt-4 mb-4" style="font-size:17px;">
                                                                           回复内容:
                                                                      </p>
                                                                      <div v-html="item.reply" style="font-size:20px;">
                                                                          {{item.reply}}
                                                                      </div>
                                                                           <div class="mt-4">
                                                                                    <div class="image_content">
                                                                                          <viewer class="mt-2" :images="imgData1"   v-for="(item,index) in imgData1"  :key="index"> 
                                                                                                    <img v-if="item!=''" class="Image mr-1 limg"
                                                                                                         :src="'http://fw.hyey.cn'+item"
                                                                                                         alt=""
                                                                                                    >
                                                                                          </viewer>
                                                                                     </div>
                                                                           </div>
                                                                      <p class="mt-2">
                                                                           <span>
                                                                              回复人:
                                                                           </span>
                                                                           <span style="color:red;">
                                                                                {{item.replytruename}}
                                                                           </span>
                                                                           <span class="ml-3">
                                                                                回复时间:
                                                                           </span>
                                                                           <span style="color:red;">
                                                                                {{item.inserttime}}
                                                                           </span>
                                                                      </p>
                                                                 </div>
                                                            </div>

                                                            <div  class="mt-3">
                                                                 <p class="text-center">
                                                                      <button class="btn btn-primary" @click="revert()">
                                                                           回复
                                                                      </button>
                                                                 </p>
                                                            </div> 
                                                  </div>
                                                  
                                       <p class="footer_author">
                                            <span>
                                                 作者:
                                            </span>
                                            <span style="color:green;">
                                                 {{author}}
                                            </span>
                                       </p>
                               </div>   
                                                         
            </div>
     </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
     data(){
          return{
              lxs:'',
              state:'',
              pageIndex:'',
              id:'',
              title:"",
              content:'',
              author:'',
              isChoose:false,
              yulan:[],
              imgData:[],
              imgData1:[],
              showActive:false,
              showimg:'',
              huifu:[],
              showHuifu:false,
              fileurl:[],
              iscollect:"",
              showVue:false,
              iscollectid:"",
              zhutitle:"",
              bumen:[],
              showRevert:false,
              username:window.sessionStorage.getItem('username'),
          }
      },
   filters:{
          changeTitle:function(title){
              if(title==null){
                       return title
                  }
                  else{
                       return title.substring(22);
                  }
        }
   },
   computed:{
       ...mapState([
            'imgUrl',
       ]),
   },
    filters:{
           handler(value){
             let wenjian=value.split("/")
            return wenjian[wenjian.length-1]
             
          },
        },
      methods:{

            getuser:async function () {
              const that=this
               const { data: res } = await that.$http.post('Dls/getuserstate',{})
              if(res.data.length==0){

              }else{
                let data=res.data[0];
                if(data.groupid==3){
                   
                }
                if(data.groupid==2){
                  
                }
                 if(data.groupid==4){
                    that.showRevert=true;
                }
                  
          }
               
                   
                   
             
        },

           //获取下发部门
           GetlogMeettop:async function(){
                  const { data: res } = await this.$http.post('Dls/GetlogMeettop', {
                             username:window.sessionStorage.getItem('username'),
                              logid:this.id,
                       })
                    //    console.log(res)
                       if(res.isok){
                            this.bumen=res.data
                       }
           },
           quxiao:async function(){
            const { data: res } = await this.$http.post('Dls/getFun', {
            action: 'ClerkUpBlog',
          obj: JSON.stringify({ 
                lxs:'8',
                id:this.iscollectid,
          })
        })

            if(res.isok){
                 if(res.data.isok){

                      alert(res.data.msg)
                      this.lookBlog();

                 }
            }
            else{
                 alert(res.message)
            }

          },


          shouchang:async function(){
            const { data: res } = await this.$http.post('Dls/getFun', {
            action: 'ClerkUpBlog',
          obj: JSON.stringify({ 
                lxs:'7',
                id:this.id,
          })
        })

            if(res.isok){
                 if(res.data.isok){
                      alert(res.data.msg)
                      this.lookBlog();
                 }
            }
            else{
                 alert(res.message)
            }

          },

           upload(item){
                
               window.location.href = 'http://fw.hyey.cn'+item;

           },
               
            showActivitiesFun:function (index,item) {  
                this.showimg='http://fw.hyey.cn'+item;
                this.isChoose = !this.isChoose  
            },
       //查看会议
       lookBlog:async function(){
              // this.getNowTime()
            const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkLookBlog',
          obj: JSON.stringify({
                username:window.sessionStorage.getItem('username'),
                lxs:'1',
                state:'0',
                id:this.id,
          })
        })
     //    console.log(res)
        if (res.isok) { 
             if(res.data.isok){
                  this.showVue=true;
                  const obj = res.data;
                  this.iscollect =obj.iscollect;
                  this.iscollectid=obj.iscollectid;

                  this.title=obj.rows[0].title;
                  if(obj.rows[0].fileurl!=null){

                       this.fileurl=obj.rows[0].fileurl.split(",")
                    //    console.log(this.fileurl)
                  }
                  // console.log(this.title)
                  this.content=obj.rows[0].contents;
                  this.imgData.push(obj.rows[0].image1,obj.rows[0].image2,obj.rows[0].image3,obj.rows[0].image4,obj.rows[0].image5);
               //    console.log(this.imgData)
                  this.author = obj.rows[0].truename;
                  this.yulan = obj.rows3;
                  this.huifu = obj.rows2;
                  if(this.huifu.length>0)
                  {
                  this.showHuifu=true;
                  this.imgData1.push(obj.rows2[0].image1,obj.rows2[0].image2,obj.rows2[0].image3,obj.rows2[0].image4,obj.rows2[0].image5);
                  }
                  else{
                       this.showHuifu=false;
                  }
                  
             }
        }
       },
    getID(){
         this.id=this.$route.query.id;
         this.zhutitle=this.$route.query.zhutitle;
        //     console.log(this.id)
      },
         //回复会议
        revert(){
            this.$router.push({path:'/revert',query:{id:this.id}})
       }

      },

      created(){
          this.getID();
          this.getuser();
          this.GetlogMeettop();
          this.lookBlog();
      }
}
</script>
<style lang="less" scoped>
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
.content_log{
     margin:0 auto;
     width:1000px;
     height:500px;
     .log_img{
          width:515px;
          height:250px;
     }
}
.log_title{
     font-size:25px;
}
// .header_title{
//      margin-top:230px;
// }
.body_content{
     // height:500px;
     margin-top:80px;
     // overflow:auto;
}
.footer_author{
     margin-top:60px;
     float:right;
     margin-right:20px;
}
.image_content{
     display: flex;
}
.limg{
     width:100px;
     height:100px;
}
.active_autoimg{
     position: absolute;
     overflow:auto;
}
.active_img{
     // left:50%;
     // top:50%;
     // margin-left:-300px;
     // margin-top:-300px;
     // width:600px;
     // height:600px;
     opacity: 1;
}
.activities_details{
     position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color:#262626;
        background:rgba(0, 0, 0, 0.5);
        z-index: 200;
}
.close_activities{
     position:absolute;
     bottom:10%;
     left:50%;
     transform: translateX(-50%);
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }

</style>




// WEBPACK FOOTER //
// src/pages/Meeting/LookMeeting.vue